module.exports = __webpack_public_path__ + "img/menu_setting_on.d34fc87f.svg";